const experimentsToCheck = [];
export const enabledExperimentsForFeedback = () => {
  return experimentsToCheck;
};